import React, { useRef } from "react"
import { useSVGMount } from "./hooks/useSVGMount"
import { useHotspotListeners } from "./hooks/useHotspotListeners"
import { useHotspotHighlight } from "./hooks/useHotspotHighlight"
import { svgContainerStyle } from "./styles"

type SVGViewerProps = {
	svgUrl: string
	onSelectHotspot: (partIndex: string) => void
	selectedPartIndex: string
}

export const SVGViewer: React.FC<SVGViewerProps> = ({
	svgUrl,
	onSelectHotspot,
	selectedPartIndex,
}: SVGViewerProps) => {
	const containerRef = useRef<HTMLDivElement>(null)

	const { status, error } = useSVGMount(svgUrl, containerRef)
	useHotspotListeners(containerRef, onSelectHotspot)
	useHotspotHighlight(containerRef, selectedPartIndex)

	return (
		<div css={svgContainerStyle}>
			{status === "error" && <p>Error: {error?.message}</p>}
			<div ref={containerRef} className="svg-container" />
		</div>
	)
}
